import { useMemo } from 'react';
import { Actions, Subjects } from 'src/constants/accessControlList';
import { useRbac } from '../features/rbac';
var useAppointmentsAllAvailabilityRbac = function () {
    var canI = useRbac().canI;
    return useMemo(function () {
        var canView = canI(Actions.View, Subjects.AppointmentsAllAvailability);
        var canEdit = canI(Actions.Edit, Subjects.AppointmentsAllAvailability);
        return {
            allAvailability: {
                canView: canView,
                canEdit: canEdit,
            },
        };
    }, [canI]);
};
export { useAppointmentsAllAvailabilityRbac };
